// extracted by mini-css-extract-plugin
export default {"matchesInfo":"matches_empty_state-module___matchesInfo___f00defeb"};